import { useEffect, useState } from 'react'
import type { PreviewLayer } from '../preview-layer'

/**
 * Loads the three.js chunk on demand. Returns null until it arrives, and stays
 * null forever when previews are disabled or the chunk fails to load, so the
 * page renders the same either way.
 */
export function usePreviewLayer(enabled: boolean): PreviewLayer | null {
  const [layer, setLayer] = useState<PreviewLayer | null>(null)

  useEffect(() => {
    if (!enabled) {
      setLayer(null)
      return
    }

    let cancelled = false
    void import('../preview-layer').then(
      (mod) => {
        if (!cancelled) setLayer({ GameView: mod.GameView, Stage: mod.Stage })
      },
      () => {
        // A failed chunk leaves the plates showing their titles, which is the
        // same result as no WebGL. Nothing to report to the visitor.
      },
    )

    return () => {
      cancelled = true
    }
  }, [enabled])

  return layer
}
